// Core packages
import { NgModule } from "@angular/core";

// Third party packages

// Custom packages - Modules
import { SharedModule } from "src/app/modules/shared.module";

// Custom packages - Components
import { DocumentArchiveExportContractsDialogComponent } from "src/app/modules/properties/components/document-archive-export-contracts-dialog/document-archive-export-contracts-dialog.component";
import { DocumentArchiveExportRasDialogComponent } from "src/app/modules/properties/components/document-archive-export-ras-dialog/document-archive-export-ras-dialog.component";

/**
 * «Esporta RAS» and «Esporta contratti» of the 3.0.0 archive (FE-M8), on their own.
 *
 * Two kinds of screens open them: the dossier of the archive, through DocumentArchiveV3Module (lazy),
 * and, once the switch is live, the legacy pages that still offer the two exports — the «SCARICA»
 * column of the property home and the «Esporta» menu of the mapping — which live in PropertiesModule,
 * i.e. in the initial bundle. A component belongs to one module only, so the dialogs sit here and
 * both import it; before Ivy a dialog is resolved by the injector of the module that opens it or by
 * the root one. That puts them in the initial bundle, as the legacy dialogs they extend.
 *
 * @since 3.0.0
 */
@NgModule({
  imports: [SharedModule],
  declarations: [DocumentArchiveExportContractsDialogComponent, DocumentArchiveExportRasDialogComponent],
  entryComponents: [
    // Pre-Ivy requirement: the dialogs are created at runtime by MatDialog
    DocumentArchiveExportContractsDialogComponent,
    DocumentArchiveExportRasDialogComponent,
  ],
})
export class DocumentArchiveExportDialogsModule {}
